import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-interbranch-multi-get',
  templateUrl: './interbranch-multi-get.component.html',
  styleUrls: ['./interbranch-multi-get.component.css']
})
export class InterbranchMultiGetComponent implements OnInit {
    interBranchMultiKeyno;

    public menu?: Menu;

    public itemsListLevels: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.interBranchMultiKeyno = this.stateService.getStateParams()['interbranchmulti_keyno'];
    }

    private async loadMenu() {
        if (!!this.interBranchMultiKeyno) {
            this.menu = (await this.datatask.Post(790, { interbranchmulti_keyno: this.interBranchMultiKeyno }))[0];
        }
    }

    private async loadLevels(): Promise<void> {
        if (!!this.menu) {
            this.itemsListLevels = await this.datatask.Post(791, { interbranchmulti_keyno: this.menu.interbranchmulti_keyno });
        }
    }

    private async init() {
        await this.loadMenu();
        this.loadLevels();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    interbranchmulti_keyno: number;
    interbranchmulti_name: string;
    stockplace_name_from: string;
    stockplace_name_to: string;
    companyname_from: string;
    companyname_to: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('interBranchMultiGet', {
//        templateUrl: 'views/components/views/interBranchMultiGet/interBranchMultiGet.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'interBranchMultiGetService', function ($stateParams, utilityService, interBranchMultiGetService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let interBranchMultiKeyno = $stateParams.interbranchmulti_keyno;

//            vm.model = {
//                menu: {},
//                itemsListLevels: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await interBranchMultiGetService.getMenu({ interbranchmulti_keyno: interBranchMultiKeyno }))[0];

//                return loadLevels();
//            }

//            async function loadLevels() {
//                if (utilityService.validateParmsValue(vm.model.menu.interbranchmulti_keyno) !== true) return;

//                return vm.model.itemsListLevels = await interBranchMultiGetService.listLevels({ interbranchmulti_keyno: vm.model.menu.interbranchmulti_keyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
